export const EVENT_COLORS = [
    { bg: "#367c2b", text: "#fff", border: "#255220" },
    { bg: "#1a4f8a", text: "#fff", border: "#123a6a" },
    { bg: "#c9ac00", text: "#fff", border: "#8a7200" },
    { bg: "#4a9e3c", text: "#fff", border: "#367c2b" },
    { bg: "#255220", text: "#fff", border: "#1a3c18" },
];